module.exports = __webpack_public_path__ + "img/menu-list.e2be9bdf.jpeg";